import React, { Component } from "react";
import ReactResizeDetector from "react-resize-detector";
import {
  XYPlot,
  XAxis,
  YAxis,
  HorizontalGridLines,
  VerticalGridLines,
  LineSeries,
  LineMarkSeries,
  DiscreteColorLegend,
} from "react-vis";

import { color, findMinMax, renderCrosshair } from "utils";

// Composant graphique pour afficher un Line chart.
class Line extends Component {
  constructor(props) {
    super(props);

    this.state = {
      crosshair: [],
      data: [],
      labels: [],
      hint: false,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.refreshes === prevState.refreshes || !nextProps.data) return null;
    const getX = nextProps.getX;
    const getY = nextProps.getY;

    let data = nextProps.data || [];
    if (nextProps.multiple === true) {
      data.forEach((line, i) => {
        let value = 0;
        data[i] = line.map((d, z) => {
          value += d.value;
          return {
            x: getX ? getX(d, z, nextProps.data) : d.label,
            y: getY ? getY(d, z, nextProps.data) : value,
            size: d.size,
          };
        });
      });
    } else {
      data = data.map((d, i) => ({
        x: getX ? getX(d, i, nextProps.data) : d.label,
        y: getY ? getY(d, i, nextProps.data) : d.value,
        size: d.size,
      }));
    }

    const labels = nextProps.labels.map((label) => ({ label }));
    return { data, labels, refreshes: nextProps.refreshes };
  }

  renderSeries(props) {
    const { hint } = this.state;
    props.sizeType = "literal";
    props.getNull = (d) => d.y !== 0;

    if (props.multiple) {
      const lines = [];
      for (let i = 0; i < props.data.length; i++) {
        const opacity = !hint || this.props.labels[i] === hint.label ? 1 : 0;
        props.markStyle = { opacity };
        props.lineStyle = { strokeOpacity: opacity };
        props.color = color(i);
        props.onNearestX = (v) =>
          this.setState({
            crosshair: [
              v,
              ...props.data.map((d, j) => ({
                ...d.find((item) => item.x === v.x),
                type: this.props.labels[j],
              })),
            ],
          });

        if (this.props.hasMarks)
          lines.push(<LineMarkSeries key={i} {...props} data={props.data[i]} />);
        else lines.push(<LineSeries key={i} {...props} data={props.data[i]} />);
      }

      return lines;
    }

    return this.props.hasMarks ? <LineMarkSeries {...props} /> : <LineSeries {...props} />;
  }

  render() {
    const { crosshair, data, labels, hint } = this.state;
    const {
      xAxisLabel,
      yAxisLabel,
      margin,
      getXDomain,
      getYDomain,
      getTickValues,
      getTickLabel,
      getYTickLabel,
      xType,
      yType,
      multiple,
      dataCount,
    } = this.props;
    const xDomain = getXDomain ? getXDomain(data) : xType !== "ordinal" && findMinMax(data, "x");
    const yDomain = getYDomain ? getYDomain(data) : yType !== "ordinal" && findMinMax(data, "y");
    const tickValues = getTickValues ? getTickValues(data) : data && data.map((d) => d.x);

    // Logique pour les effets du hover.
    labels.map((l) => {
      if (hint) {
        l.className = l.label === hint.label ? "hovered" : "not-hovered";
      } else {
        l.className = "";
      }
    });

    const seriesProps = {
      color: color(0),
      animation: this.props.animation === undefined ? "noWobble" : this.props.animation,
      data: data,
      onNearestX: (v) => this.setState({ crosshair: [v] }),
      multiple,
      dataCount,
    };

    return (
      <ReactResizeDetector handleWidth>
        {({ width }) => {
          width = width > this.props.minWidth ? width : this.props.minWidth;
          return (
            <div className="line-chart-wrap">
              {this.props.labels && (
                <DiscreteColorLegend
                  orientation={this.props.legendOrientation}
                  items={(labels.slice(0, 10) || []).map((l, i) => ({
                    title: l.label,
                    color: color(i),
                    strokeWidth: 6,
                    disabled: l.className === "not-hovered",
                    hint: { ...l },
                  }))}
                  onItemMouseEnter={(item) => this.setState({ hint: item.hint })}
                  onItemMouseLeave={() => this.setState({ hint: false })}
                />
              )}
              <XYPlot
                width={width}
                height={this.props.height}
                xDomain={xDomain}
                yDomain={yDomain}
                xType={xType}
                margin={margin}
                onMouseLeave={() => this.setState({ crosshair: [] })}
              >
                <VerticalGridLines />
                <HorizontalGridLines />
                <XAxis
                  title={xAxisLabel}
                  tickValues={tickValues || undefined}
                  tickFormat={getTickLabel || undefined}
                  tickLabelAngle={-30}
                />
                <YAxis title={yAxisLabel} tickFormat={getYTickLabel || undefined} />
                {this.renderSeries(seriesProps)}

                {renderCrosshair(
                  crosshair,
                  this.props.crosshair && this.props.crosshair(crosshair),
                )}
              </XYPlot>
            </div>
          );
        }}
      </ReactResizeDetector>
    );
  }
}

export default Line;
